import React from 'react'
import PropTypes from 'prop-types'
import SortIcon from '../../../assets/codicons/sort'

let SortableListLabel = props => {
  let renderLabel = option => {
    if (option === 'az') {
      return (
        <span>
          A <i className='fa fa-long-arrow-right' /> Z
        </span>
      )
    } else {
      return <span>{props.optionTitles[option]}</span>
    }
  }

  let handleClick = e => {
    e.preventDefault()
    props.onClick()
  }

  let arrow = props.menuOpen ? (
    <i className='fa fa-angle-up' />
  ) : (
    <i className='fa fa-angle-down' />
  )

  return (
    <a href='#' onClick={handleClick}>
      <span className='SortableList__shown-label'>
        {renderLabel(props.currentOrder)}
      </span>
      {!props.isMobile ? arrow :<SortIcon/>}
      
    </a>
  )
}

SortableListLabel.propTypes = {
  currentOrder: PropTypes.string,
  onClick: PropTypes.func,
  optionTitles: PropTypes.object,
  menuOpen: PropTypes.bool,
  isMobile: PropTypes.bool
}

export default SortableListLabel
